import React, { useState } from 'react'
import {
    AutoComplete,
    Tag,
    Input,
    Button,
    message,
    Form,
    Modal,
} from "antd";
import { validateEmail } from '../../../utils/utils';
import axiosInstance from "../../../utils/axiosInstance";

const { TextArea } = Input;


export default function SentAgreementModel({ isOpen, onClose, agreement_id }) {
    const [units, setUnits] = useState([]); // Added units
    const [inputValue, setInputValue] = useState(""); // Current input
    const [options, setOptions] = useState([]); // AutoComplete options
    const [loading, setLoading] = useState(false); // Loading state
    const [isDisableSubBtn, setIsDisableSubBtn] = useState(false);
    const [form] = Form.useForm();

    const onClear = () => {
        setUnits([]);
        setInputValue('')
        setOptions([]);
        setLoading(false);
        form.resetFields()
    }

    const handleClose = (removedUnit) => {
        setUnits(units.filter((unit) => unit !== removedUnit));
    };


    // Handle selecting from AutoComplete dropdown
    const handleSelect = (value) => {
        if (!units.includes(value)) {
            setUnits([...units, value]);
            setInputValue("");
            setOptions([]);
        }
    };

    // Handle adding unit when Enter or Comma is pressed
    const handleKeyDown = (event) => {
        if (event.key === "Enter" || event.key === ",") {
            event.preventDefault();
            const unit = inputValue.trim();

            if (!validateEmail(unit)) {

                form.setFields([
                    {
                        name: "receiver",
                        errors: ["Put a valid email address ."], // Sets error on the input field
                    },
                ]);
                // setInputValue(""); // Clear input

            } else if (units.includes(unit)) {

                form.setFields([
                    {
                        name: "receiver",
                        errors: ["Duplicate email address not allow ."], // Sets error on the input field
                    },
                ]);
                // setInputValue(""); // Clear input

            } else if (!!unit) {

                setUnits([...units, unit]);
                setInputValue(""); // Clear input
                setOptions([]); // Clear options
                form.resetFields()

            } else {
                setInputValue(""); // Clear input
            }

        }
    };

    const fetchSuggestions = async (query) => {
        if (query.length < 3) {
            setOptions([]); // Clear options if less than 3 chars
            return;
        }
        try {
            setLoading(true); // Show loading indicator
          const  response = await axiosInstance.post(`/user/SearchUserAPIView/`,{ search_keyword: query })
            if (response.status === 200) {
                const emails = response.data.filter((data) => !units.includes(data.email)).map((item) => ({ value: item.email }));
                setOptions(emails);
            } else {
                setOptions([]);
            }
        } catch (error) {
            setOptions([]);
        } finally {
            setLoading(false);
        }


        // const response = await new Promise((resolve) =>
        //   setTimeout(
        //     () =>
        //       resolve(
        //         ["Apple", "Banana", "Cherry", "Avocado", "Apricot"].filter((item) =>
        //           item.toLowerCase().includes(query.toLowerCase())
        //         )
        //       ),
        //     1000 // Simulating a delay
        //   )
        // );

        // setOptions(response.map((item) => ({ value: item })));
        // setLoading(false); // Hide loading indicator
    };

    const onOk = async () => {
        try {
            const values = await form.validateFields();
            console.log(values,units )
            const allunits = [...units]
            if ( values && units.includes(values.receiver) ){
                form.setFields( [
                    {
                        name: "receiver",
                        errors: ["Duplicate email address not allow ."], // Sets error on the input field
                    },
                ] );

                return; // Stop submission if there's an existing error
            }

            if (inputValue) {
                if( !validateEmail(inputValue) ){

                    form.setFields([
                        {
                            name: "receiver",
                            errors: ["Put a valid email address ."], // Sets error on the input field
                        },
                    ]);
    
                    return;
                }else{
                    allunits.push(inputValue)
                }
            }
            setIsDisableSubBtn(true)
            const payload = {
                agreement_id,
                receiver: allunits,
                remark: values.remark
            }
            const  response = await   axiosInstance.post( `/esign/sendagreement/`,payload )
            if (response.status === 200) {
                message.success(response.data.message)
                onClose();
                onClear();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsDisableSubBtn(false)
        }
    }

    return (
        <Modal
            title="Send Agreement"
            open={isOpen}
            onOk={() => form.submit()}
            onCancel={() => {
                onClose();
                onClear();
            }}
            style={{ fontSize: "24px", padding: "40px" }}
            okText="Send"
            okButtonProps={{
                disabled: isDisableSubBtn, // Disabl
                loading: isDisableSubBtn,
                style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                },
            }} // Set background color for the Ok button
            cancelButtonProps={{
                disabled: isDisableSubBtn, // Disabl
                style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                },
            }} // Set background color for the Cancel button
        >
            <Form form={form} onFinish={onOk}>
                <h1 className="font-lg">Receiver's Email</h1>
                <Form.Item name="receiver"
                    rules={[{ required:( !inputValue ? !units.length : true ), message: "Receiver's Email field is required!" }]}
                    className="pt-1">
                    <div
                        style={{
                            border: "1px solid #d9d9d9",
                            padding: "5px",
                            borderRadius: "5px",
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                        }}
                    >
                        {units.map((unit) => (
                            <Tag key={unit} closable={!isDisableSubBtn} onClose={() => handleClose(unit)} style={{ marginBottom: "5px" }}>
                                {unit}
                            </Tag>
                        ))}

                        <AutoComplete
                            options={loading ? [] : options} // Hide options while loading
                            onSelect={handleSelect}
                            value={inputValue}
                            onChange={setInputValue}
                            onSearch={fetchSuggestions}
                            style={{ flex: 1, minWidth: "150px", border: "none" }}
                            placeholder="Start typing (min 3 chars)..."
                            disabled={isDisableSubBtn}
                        >
                            <Input
                                onKeyDown={handleKeyDown}
                                style={{ border: "none" }}

                            />
                        </AutoComplete>
                    </div>
                </Form.Item>

                <h1 className="font-lg">Remark</h1>
                <Form.Item name="remark" className="pt-1">
                    <TextArea  disabled={isDisableSubBtn} />
                </Form.Item>
            </Form>
        </Modal>
    )
}